import styled, { createGlobalStyle, css } from "styled-components";
import {Colors, FInter, FlexBox, MagicBox} from "@brg/ui";
import changebg from "./changebg.svg";
import changebgsquare from "./changebgsquare.svg";
import { bColor } from "../../../core/utils/bColor";
import { LabelRedStar } from "../designerEditView/styles";
import { IconWrapperAdd } from "../../assets/styles";
import { BTagsGrid } from "../../../core/components";
import { LayoutConst } from "core/modules";
import { FadeAnimation } from "./SelectPointComponentNext";
import hexToRGB from "shared/helpers/hexToRGB";
import {PageViewportLayout} from "../../components/template";
import {Link} from "react-router-dom";
import { Input } from "@brg/input";
import { BTagsGridNew } from "core/components/bTag/bTagsGridNew/bTagsGridNew";

export const ProjectAuthorsWrapper = styled(FlexBox)<{ isTeamEdit?: boolean, isCompetitionEdit?: boolean, isProjectEdit?: boolean, isCompetitions?: boolean, isLMS?: boolean }>`

${({ isTeamEdit, isCompetitionEdit }) => (isTeamEdit || isCompetitionEdit) ? css`
  max-width: 100%;
  width: 100%;

  .add-button {
    height: ${isTeamEdit ? '36px' : '32px'};
    max-height: ${isTeamEdit ? '36px' : '32px'};
    min-height: ${isTeamEdit ? '36px' : '32px'};
    span {
      font-size: ${isTeamEdit ? '15px' : 'inherit'};
      line-height: ${isTeamEdit ? '20px' : 'inherit'};
    }
  }

  .input-wrapper {
    background-color: ${({theme}) => theme.competition.input.bg} !important;
    color: ${({theme}) => theme.competition.input.inputText} !important;
    height: 46px;
    border-radius: 3px;
  }

  .result-dropdown-wrapper {
    * {
      background-color: ${({theme}) => theme.competition.input.bg};
    }
  }

` : null};

  & > :first-child {
    margin-bottom: 16px;
  }
  ${({ isProjectEdit }) => isProjectEdit ? css`
  @media(max-width: ${LayoutConst.screen.m}px){
    & > :first-child {
      margin-bottom: 24px;
    }
  }

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    & > :first-child {
      margin-bottom: 16px;
    }
  }
  ` : null};

    ${({ isTeamEdit, isCompetitionEdit, isLMS, isProjectEdit }) => (isTeamEdit) ? null : isLMS ? css`
    .input-wrapper {
      height: 100%;
      input {
        height: 100%;
      }
    }
    ` : isCompetitionEdit ? css`
    .input-wrapper {
      height: 40px;
      input {
        height: 40px;
      }
    }
    ` : isProjectEdit ? css`

      .search-wrapper_second, 
      .input-wrapper, input, 
      .dropdown-wrapper, 
      .item, 
      .dropdown-wrapper__text,
      .search-msg {
        background-color: ${({theme}) => theme.mainSearchBar.bg} !important;
        color: ${({theme}) => theme.competition.input.inputText} !important;
      }

      input {
        ::placeholder {
          color: ${({theme}) => theme.mainSearchBar.input.placeholder};
        }
      }

      @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        max-width: 100%;

        .search-wrapper {
          max-width: 256px !important;
        }
      }

      @media(max-width: ${LayoutConst.screen.m}px) {
        .search-wrapper {
          max-width: 100% !important;
        }
      }
    ` : css`
    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      max-width: 100%;



      .search-wrapper {
        max-width: 293px !important;
      }
    }

    @media(max-width: ${LayoutConst.screen.m}px) {
      .search-wrapper {
        max-width: 100% !important;
      }
    }
    `}

  @media (max-width: ${LayoutConst.screen.md}px) {
    & > :not(:first-child) {
      margin-left: 20px;
    }
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    flex-flow: column wrap;

    & >:not(:first-child) {
      margin-left: 0;
    }
  }

  @media(max-width: ${LayoutConst.screen.s}px) {
    max-width: 100%;
    width: 100%;
  }
  
  ${({ isCompetitions }) => isCompetitions && css`
    @media (max-width: ${LayoutConst.screen.md}px) {
      width: 100%;
      max-width: none;
    }
    @media (max-width: ${LayoutConst.screen.s - 1}px) {
      width: 100%;
      max-width: none;
    }
    `}
`;

export const ProjectLocationWrapper = styled(FlexBox)<{isMobile?: boolean}>`
  place-items: ${p => p.isMobile ? "start" : "normal"};

  * {
    margin-left: ${p => p?.isMobile ? '0 !important' : 'inherit'};
  }

  @media(max-width: ${LayoutConst.screen.sm}px) {
    flex-flow: column;
    place-items: flex-start;

    & * {
      margin-left: 0 !important;
    }
  }
`;

export const ProjectEditPageContainer = styled(FlexBox)<{ isFullHeight?: boolean, reverseBlocksOnMob?: boolean, isProjectEdit?: boolean }>`
  flex-direction: column;
  width: 100%;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  .brg-input__value-container {
    height: 34px;
  }
  
  .white_bg {
   .brg-input__control, input {
        background-color: ${({ theme }) => theme.projectEdit.imgContainerBg};
        border-color: transparent;

            .brg-input__placeholder {
                color: #909090;
            }
            &:focus {
                border-color: #30363A;
                .brg-input__placeholder {
                    color: #909090;
                }
            }
            &:active {
                border-color: #30363A;
                .brg-input__placeholder {
                    color: #909090;
                }
            }
            &:hover {
                border-color: #30363A;
                .brg-input__placeholder {
                    color: #909090;
                }
            }

    }

    .brg-input__multi-value__label, .brg-input__single-value  {
        color: #151514;
    }

    .brg-input__multi-value {
        background-color: transparent;
        padding-top: 4px;
        svg path {
            fill: #151514;
            cursor: pointer;
        }
    }

    .brg-input__multi-value__remove {
        cursor: pointer;
        &:hover {
            background-color: transparent;
        }
    }

    .brg-input__menu-list {
        &::-webkit-scrollbar {
          height: 1px;
          width: 2px;
        }
        &::-webkit-scrollbar-track {
          border-radius: 10px;
          background: ${({theme}) => theme.competition.input.bgActive} !important;
        }
        &::-webkit-scrollbar-thumb {
          background: ${({theme}) => theme.competition.input.inputText} !important;
        }
      }
    
      .brg-input__menu {
        background-color: ${({theme}) => theme.competition.input.bg} !important;
    
        .brg-input__option {
          cursor: pointer;
          color: ${({theme}) => theme.competition.input.inputText} !important;
          svg {
            path {
              fill: ${({theme}) => theme.competition.input.inputText} !important;
            }
          }
        }
        .brg-input__option--is-focused {
          background-color: ${({theme}) => theme.competition.input.bgActive} !important;
        }
        .brg-input__option--is-focused:hover {
          background-color: ${({theme}) => theme.competition.input.bgActive} !important;
        }
      }

      .brg-input__indicators {
        align-items: start;
      }
      
      .brg-input__indicator {
        padding-top: 14px;
        margin-right: 0;
        svg {
          path {
            fill: ${({theme}) => theme.competition.input.inputText} !important;;
          }
        }
      }

    input {
        &:disabled {
            color: #909090 !important;
        }
    }

    .showcase-switcher {
        margin: auto 0 0 0;
    }
  }

  .tagss {
    .brg-input__control {
      width: 432px;
      overflow-x: scroll;
      overflow-y: hidden;
      padding-top: 3px;

      &::-webkit-scrollbar {
        display: none;
      }
    }

    .brg-input__value-container {
      width: auto !important;
      min-width: 10000px;
      max-width: 10000px;
      height: 40px;
      overflow: hidden;
    }
  }

  .brg-input__control {
    .gixVUY {
      top: -1px;
    }
  }

  .brg-input__option {
    position: relative;
  }

  .brg-input__menu-list {
    //min-height: 280px;
  }

  .brg-input__menu {
    z-index: 2000;
  }

  //@fixme: Z-position error
  .brg-input__menu {
    z-index: 100 !important;
  }

  .head__grey {
    margin-top: 0;
    padding-top: 0;
  }

  .brg-input__value-container {
    overflow: hidden;
    max-height: 40px;
  }

  @media (max-width: 940px) {
    margin-top: 0px;

    ${({ reverseBlocksOnMob }) => 
      reverseBlocksOnMob 
      ? 
      css`
        .author-wrapper {
          order: 2;
          margin-top: 32px;
        }
        .tags-wrapper {
          order: 1;
        }
        .place-wrapper {
          order: 3;
        }
        .errors-wrapper {
          order: 4;
        }
      ` 
      : null};

      .mobile-block-2 {
        order: 1;
      }
      .game-create-wrapper {
        order: 11;
        margin-top: 0!important;
      }
      .voting-checkbox-wrapper {
        order: 10;
        margin-top: 24px;
      }
      .mobile-block-3 {
        order: 2;
        flex-direction: column;

        .places-wrapper-tags-block {
          margin-top: 16px;
        }
      }
      .mobile-block-5 {
        order: 10;
        flex-direction: column;
        place-items: baseline;
      }
      .mobile-block-4 {
        order: 3;
        flex-direction: column !important;
        justify-content: flex-start;

        .project-tags-block {
          place-items: flex-start;
        }

        .tags-wrapper-grid-block {
          max-width: 100%;
          margin-top: 16px;
          margin-left: 0;

          * {
            margin-left: 0;
          }
        }
      }

      .mobile-block-15 {
        order: 6;
      }
      .mobile-block-7 {
        order: 5;
      }
      .mobile-block-6 {
        order: 4;
        flex-direction: column !important;
        justify-content: flex-start;

        .project-tags-block {
          place-items: flex-start;
        }

        .tags-wrapper-grid-block {
          max-width: 100%;
          margin-top: 16px;
          margin-left: 0;

          * {
            margin-left: 0;
          }
        }
      }
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    margin-top: 24px;
  }

  // ${({ isProjectEdit}) => isProjectEdit ? css`
  //   @media(max-width: 940px) {
  //     margin-top: 0;
  //   }
  // ` : null};
    
  ${({ isFullHeight}) => isFullHeight ? css`
    @media(min-width: ${LayoutConst.screen.s}px) {
      height: 100%;
    }
  `: null};
`;

export const ProjectEditPageGrid = styled(FlexBox)<{ isTeamPage?: boolean, isAdditional?: boolean }>`
  flex-direction: column;
  width: 100%;
  height: 100%;

  .checkbox {
    &:hover {
        background-color: transparent !important;
    }
  }

  @media(max-width: 1280px) {
   .books-publisher-wrap, .books-biblio-wrap {
      flex-direction: column;
      align-items: flex-start;
    }
    .books-label {
      margin-bottom: 16px;
    }
  }

  @media(max-width: 940px) {

    .books-tags-wrap {
      flex-flow: column;
    }

    ${({ isTeamPage, isAdditional }) => isTeamPage ? css`
      margin: 0 auto;
      padding-top: ${isAdditional ? 0 : '24px'};
      justify-content: center;
      max-width: 760px;

      > div {
        width: 760px;
      }
    ` : null};

    .mobile__wrap {
      flex-wrap: wrap !important;
    }
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    ${({ isTeamPage }) => isTeamPage ? css`
      margin: 0 20px;
      justify-content: center;
      max-width: 760px;


    > div {
      width: 760px;
    }
  ` : null};
    .errors-wrapper {
      order: 10;
      margin-bottom: 24px;
    }
  }

  @media(max-width: ${LayoutConst.screen.s}px) {

    ${({ isTeamPage }) => isTeamPage ? css`
      width: calc(100% - 20px);
      margin: 0 auto;

      > div {
        width: 100%;
      }
  ` : css`
      max-width: 100%;
      //width: calc(100% - 20px);
      width: 100%;
      margin: 0 auto;

      > div {
        width: 100%;
      }
      .errors-wrapper {
        margin-bottom: 16px;
      }
  `}
  }

`;

export const QueuePublishButton = styled.div`
    display: flex;
    padding: 12px 48px;
    justify-content: center;
    align-items: center;

    border-radius: 3px;
    background: ${Colors.galBlack100};

    color: #FFF;
    font-family: Inter;
    font-size: 17px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: -0.34px;
    
    @media (max-width: ${LayoutConst.screen.sm}px) {
        width: 100%;
    }
`

export const ProjectEditPageGridRow = styled(FlexBox)<{ isProjectEdit?: boolean, isBook?: boolean, center?: boolean, isTeamEdit?: boolean, isCheckbox?: boolean, switchValue?: number, isProDeziiign?: boolean  }>`

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }

  ${({ isProjectEdit }) => isProjectEdit ? css`

    display: flex;
    align-items: center;
    height: 48px;
    max-height: 48px;
    min-height: 48px;

    @media (max-width: ${LayoutConst.screen.mac13}px) {
      height: 40px;
      max-height: 40px;
      min-height: 40px;
    }
  
    ` : null};


  ${({ isTeamEdit }) => isTeamEdit && css`
    input {
      padding-top: 15px;
      padding-bottom: 13px;
    }

    .info-icon-wrapper{
      margin-right: 8px;
    }

    .add-button {
      height: 36px;
      max-height: 36px;
      min-height: 36px;

      span {
        font-size: 15px;
        line-height: 20px;
      }
    }

    .small-caption {
      font-size: 17px;
      line-height: 22px;
    }

    .brg-input__control {
      .brg-input__indicator {
        opacity 1 !important;
        transition: none;
        svg path {
            fill: #909090 !important;
        }
      }
    }
      @media(max-width: ${LayoutConst.screen.m}px){
        max-width: 720px;
    }
  `};

  .input-span {
    color: rgba(144, 144, 144, 1);
  }

  .header-description {
    font-size: 17px;
    line-height: 22px;
    font-weight: 400;
    color: rgba(144, 144, 144, 1);
  }

  .showcase-switcher {
    margin-bottom: 0;
    height: 24px;
    width: 48px;

    span:not(:last-child) {
      background-color: rgba(112, 112, 111, 1);
      border-radius: 19px;
    }

    span:last-child {
      top: 50%;
      transform: translateY(-50%);
      width: 16px;
      height: 16px;
      border-radius: 50%;
      left: 10%;
      ${({ switchValue }) => switchValue === 0 ? css`
      background-color: #fff;
      ` : css`
        left: 57%;
      `};
    }
  }

  .tags-container {
    max-width: 413px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      max-width: 293px;
    }

    @media (max-width: ${LayoutConst.screen.md}px) {
      max-width: 100%;
    }
  }
  
  ${({ center}) => center ? css`
    place-items:center;
  `: null};
  &:not(:first-child) {
    margin-top: ${({ isTeamEdit, isProDeziiign }) => isTeamEdit || isProDeziiign ? 0 : '24px'};
  }

  @media(max-width: 940px) {
    ${({ center}) => center ? css`
    place-items:normal;
  `: null};
    .project-tags-block {
      flex-direction: column !important;
    }

    &:not(:first-child) {
      margin-top: ${({ isTeamEdit, isProDeziiign }) => isTeamEdit || isProDeziiign ? 0 : '24px'};
    }
    &.mobile__hide {
      display: none;
    }
  }

  @media(max-width: ${LayoutConst.screen.m}px) {
    align-items: start;
    flex-flow: column;
    width: 100%;
    
    ${({ isTeamEdit, isCheckbox }) => isTeamEdit ? css`
      flex-flow: ${isCheckbox ? 'row-reverse' : 'column'};
      width:100%;
      &:not(:first-child) {
        margin-top: 8px;
      }
    ` : null};
  }

  @media(max-width: 440px) {

    ${({ isBook }) => isBook ? css`
    .add-button {
      margin-left: 0 !important;
    }
      input {
        max-width: 202px;
      }
    ` : null}
  }
`;

export const AuthorsLabelContainer = styled.div<{ 
  isTeamEdit?: boolean,
  isPresentation?: boolean,
  isProjectEditPage?: boolean
}>`
  display: flex;
  align-items: center;
  margin-right: 16px;
  
  ${({ isTeamEdit, isPresentation, isProjectEditPage }) => {
    if (isPresentation) {
      return css`
        display: none;
      `;
    }
    if (isProjectEditPage) {
      return css`
        margin-right: 0;
      `;
    }
    if (isTeamEdit) {
      return css`
        margin-right: 12px;
      `;
    }

    
    return css`
      margin-right: 16px;
    `;
  }}

  > div {
    width: 160px;
    min-width: 160px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      width: 130px;
      min-width: 130px;
    }
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    margin-right: 12px;
  }
`;

export const ProjectEditPageGridAuthorRow = styled(FlexBox)<{ isTeamEdit?: boolean, isCompetitions?: boolean, isPresentationLMS?: boolean, isPresentation?: boolean }>`
  place-items: flex-start;

  ${({ isPresentation }) => isPresentation && css`
    width: 100%;

    input {
      background-color: #fff;
    }

    .input-wrapper {
      padding: 0;
    }

    .text-wrapper {
      font-size: 13px;
      line-height: 16px;
      overflow-y: hidden;
    }
  `};
  &:not(:first-child) {
    margin-top: ${({ isTeamEdit }) => isTeamEdit ? 8 : '8px'};
    
    @media (max-width: ${LayoutConst.screen.m}px) {
      margin-top: ${({ isTeamEdit }) => isTeamEdit ? '24px' : '0'};

      .basic-multi-select {
        margin-top: 16px !important;
      }
    }
  }

  @media(max-width: ${LayoutConst.screen.s}px) {
    ${({ isTeamEdit }) => isTeamEdit ? css`
      flex-flow: column;
      width: 100%;
    ` : null};
  }
  
  ${({isCompetitions}) => isCompetitions && css`
    margin-top: 24px;
    margin-bottom: 0!important;

    @media (max-width: ${LayoutConst.screen.md}px) {
      width: 100%;
      max-width: none;
    }
  `}
  
  ${({isPresentationLMS}) => isPresentationLMS && css`
    flex-direction: column;
  `}
`;

export const ProjectEditPageGridLabel = styled(FInter.SmallTextFlex)<{ 
  minHeight?: number, 
  isPresentation?: boolean, 
  isProjectEditPage?: boolean, 
  fullWidth?: boolean, 
  isTeamEdit?: boolean, 
  isLMS?: boolean, 
  isTable?: boolean, 
  isCheckbox?: boolean, 
  fixedHeight?: boolean, 
  nowrap?: boolean, 
  isPresentationLMS?: boolean, 
  isTeacherLMS?: boolean 
}>`
  font-size: 15px;
  line-height: 20px;
  color: ${({ theme }) => theme.projectEdit.label};
  width: ${({ fullWidth, isProjectEditPage }) => fullWidth ? 'auto' : isProjectEditPage ? '160px' : '160px'};
  min-width: ${({ fullWidth, isProjectEditPage }) => fullWidth ? 'auto' : isProjectEditPage ? '160px' : '160px'};
  align-items: center;
  margin-right: 24px;
  position: relative;

  ${({ minHeight }) => minHeight && css`
    min-height: ${minHeight}px;
    margin-top: 0 !important;
  `};

  ${({ fixedHeight }) => fixedHeight ? css`
    height: 32px;
    max-height: 32px;
    padding-top: 0;
  ` : null};

  ${({ nowrap }) => nowrap && css`
    white-space: nowrap;
  `};

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
    margin-right: 16px;
    width: ${({ fullWidth, isProjectEditPage }) => fullWidth ? 'auto' : isProjectEditPage ? '130px' : '130px'};
    min-width: ${({ fullWidth, isProjectEditPage }) => fullWidth ? 'auto' : isProjectEditPage ? '130px' : '130px'};
    ${({ fixedHeight }) => fixedHeight ? css`
    padding-top: 0;
    min-height: 40px;
  ` : null};

  ${({ nowrap }) => nowrap && css`
    white-space: nowrap;
  `};

    ${({ isLMS }) => isLMS ? css`
      min-width: auto;
      width: 100%;
      margin-bottom: 8px;    
    ` : null};
  }

  @media (max-width: 940px) {
    font-size: 13px;
    line-height: 16px;
    width: ${({ isPresentation, isTeacherLMS, isLMS, fullWidth }) => fullWidth || isPresentation || isTeacherLMS || isLMS ? 'auto' : '76px'};
    min-width: ${({ isPresentation, isTeacherLMS, isLMS, fullWidth }) => fullWidth || isPresentation || isTeacherLMS || isLMS ? 'auto' : '76px'};
    white-space: ${({ nowrap }) => nowrap ? 'nowrap' : 'wrap'}!important;
    margin-bottom: 8px;
    margin-right: ${({ isPresentation }) => isPresentation ? '0' : '24px'};

    ${({ isTeamEdit, isTable }) => isTeamEdit ? css`
      min-width: 170px;
      font-size: ${isTable ? '13px' : '17px'};
      line-height: ${isTable ? '16px' : '22px'};
  ` : null};
  }

  @media(max-width: 834px) {
    white-space: ${({ nowrap }) => nowrap ? 'nowrap' : 'wrap'}!important;

    ${({ isTeamEdit }) => isTeamEdit ? css`
      min-width: 170px;
    ` : null};
  }

  @media(max-width: ${LayoutConst.screen.s}px) {
    ${({ isTeamEdit, isTable, isCheckbox }) => isTeamEdit ? css`
      margin-bottom: ${isCheckbox ? 0 : '8px'};
      font-size: ${isTable ? '13px' : '15px'};
      line-height: ${isTable ? '16px' : '20px'};
      white-space: nowrap;
      width: 100%;
      min-width: none;
    ` : null};
  }

  ${({ isPresentationLMS, isPresentation }) => (isPresentationLMS || isPresentation) && css`
    min-width: auto;
    width: auto;
  `};
}
`;

export const ProjectEditPageGridStartLabel = styled(ProjectEditPageGridLabel)`
  align-items: start;
`;

// выбор бг на дезигне

interface IBgLayout {
  color: string;
  brighter?: string;
  darker?: string;
}

export const GlobalColoring = createGlobalStyle<IBgLayout>`
  ${(props) =>
    props.color && props.color !== ""
      ? css`          .custom_title {
            color: ${bColor.isDark(props.color)
              ? Colors.geoWhite100
              : Colors.galBlack100};
          }
          ${LabelRedStar} {
            color: ${bColor.isDark(props.color) ? "#ff0000" : Colors.redFailed};
          }
        `
      : null};
`;
export const BgLayout = styled.div<IBgLayout>`
  background-color: ${(props) =>
    props.color === "" ? "inherit" : props.color};
  transition: background-color 500ms;

  // вырубаем линии у лонгридов

  @media(max-width: 940px) {
    .add-block__wrap {
      display: none !important;
    }
  }
`;

export const ChangeBgBtn = styled.div`
  display: inline-block;
  width: 36px;
  height: 36px;
  background: url(${changebgsquare}) no-repeat center;
  cursor: pointer;
  position: relative;
  vertical-align: middle;
  border-radius: 3px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: 28px;
    height: 28px;
  }
`;

export const UserColorChoose = styled.div`
  position: relative;
  display: inline-block;
  width: 32px;
  height: 32px;
  vertical-align: middle;
  cursor: pointer;
  margin: 0 16px 16px 0;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: 28px;
    height: 28px;
    margin: 0 11px 16px 0;
  }
`;

export const UserColorChooseBlock = styled.div<{mobileLeftOffset?: number | string}>`
  position: absolute;
  left: -70px;
  bottom: 40px;
  box-shadow: 0 1px 16px 0 rgba(34, 60, 80, 0.2);
  z-index: 101;
  width: 100%;

  @media (max-width: 940px) {
    left: 0;
  }

  @media (max-width: 500px) {
    ${p => p.mobileLeftOffset && `left: -${p.mobileLeftOffset}px;`}
  }
`;

export const AddButton = styled(IconWrapperAdd)<{ disabled?: boolean, fs?: boolean, isTeamEdit?: boolean }>`
  cursor: pointer;
  height: 48px;
  display: ${p => p?.disabled ? 'none' : 'flex'};
  align-items: center;
  
  &:not(:first-child) {
    margin-left: 16px;
  }

  //todo проверить. Не работает и нет такого кейса в макетах.
  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    height: 40px;
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    ${({ fs }) => fs ? css` width: 100%` : null};
  }
`

export const AlignedTagsGrid = styled(BTagsGrid)<{ fs?: boolean, isProjectEdit?: boolean, isTeamEdit?: boolean, maxHgt?: boolean }>`
  align-items: center;
  max-width: ${fs => fs ? '100%' : 'calc(100% - 40px)'};

  ${({ isProjectEdit, isTeamEdit, maxHgt }) => ((isProjectEdit || isTeamEdit) && maxHgt) ? css`
    max-height: ${isTeamEdit ? '85px' : '135px'};
    overflow-y: auto;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      max-height: ${isTeamEdit ? '85px' : '120px'};
      max-width: ${isProjectEdit ? '293px' : '100%'};
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
      max-height: ${isTeamEdit ? '85px' : '135px'};
      margin-right: ${isTeamEdit ? '0': 'inherit'};
    }

    @media(max-width: 834px) {
      max-height: ${isTeamEdit ? '85px' : '115px'};
    }

    @media(max-width: 576px) {
      max-height: 135px;
    }
  ` : null};
`


export const MobilePadding = styled.div`
  margin-top: 80px;
`;

export const MobileCreateButton = styled.button`
  position: fixed;
  top: 18px;
  z-index: 100000;
  right: 69px;
  color: white;
  background: #151514;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  padding: 4px 16px;
  font-weight: 700;
  font-size: 13px;
  border: none;
  line-height: 20px;
  &:disabled {
    opacity: 0.7;
  }
`;

export const MapSearchContainer = styled(FlexBox)<{ offset?: boolean }>`
  position: fixed;
  display: flex;
  width: 100%;
  top: 48px;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1006;
  animation: 0.2s ease-in forwards ${FadeAnimation};
  background-color: ${(p) => p.theme.map.bg};

  @media(max-width: ${LayoutConst.screen.md}px) {
    top: ${({ offset }) => offset ? '48px' : 0};
    z-index: ${({ offset }) => offset ? '1006' : '99999'};
  }
`;

export const MapTopLine = styled.div`
  @media(max-width: ${LayoutConst.screen.md}px) {
    content: '';
    width: 38px;
    height: 2px;
    position: absolute;
    display: inline-block;
    background-color: #6C7073;
    top: 6px;
    left: 50%;
    transform: translateX(-50%);
  }
`;

export const MapSearchContentWrapper = styled(FlexBox)`
  background-color: ${(p) => p.theme.map.bg};
  margin: 0 auto;
  width: calc(65% + 40px + 400px);
  max-width: 100%;
  justify-content: center;

  @media(max-width: ${LayoutConst.screen.l}px) {
    padding: 0 10px;
  }

  // @media(max-width: ${LayoutConst.screen.md}px) {
  //   width: 100%;
  //   overflow-y: auto;
  //   position: relative;

  // }
`;

export const GeoLocationText = styled(FInter.SmallTextBoldDiv)`
  color: #E7E7E7;
  font-size: 17px;
  line-height: 22px;
  font-weight: 400;
`;

export const GeoLocationCoordsText = styled.div`
  font-size: 13px;
  line-height: 16px;
  font-weight: 400;
`;

export const LongreadWrapper = styled(FlexBox)<{ hseFonts?: boolean }>`
  * {
    font-family: ${({ hseFonts }) => hseFonts ? 'HSE Slab' : 'Inter'};
  }
`;


export const CheckboxRoot = styled.div<{ checked?: boolean, isProjectPage?: boolean }>`
  width: 24px;
  height: 24px;
  min-width: 24px;
  border: 1px solid ${({ theme, isProjectPage }) => isProjectPage ?
    theme.projectEdit.btns.age.border : theme.projectEdit.btns.lang.biling.border};
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({theme, isProjectPage}) => isProjectPage ? theme.projectEdit.btns.age.bg : theme.projectEdit.btns.lang.biling.bg};
  input {
    display: none;
  }

  svg path {
    fill: ${({ theme }) => theme.projectEdit.btns.age.icon.color};
  }
`
export const BilingualismWrapper = styled(FlexBox)`
    gap: 0 24px;
    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      gap: 0 16px;
    }
`;
export const BilingualismContent = styled(FlexBox)`
    gap: 8px;
`;
export const BilingualismLabel = styled(FlexBox)`
  min-width: 160px;
  font-size: 15px;
  line-height: 20px;
  color: ${({ theme }) => theme.projectEdit.label};
  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
    margin-right: 0px;
    min-width: 130px;
  }`
export const BilingualismItem = styled(FlexBox)`
  font-size: 15px;
  line-height: 20px;
  color: ${({ theme }) => theme.projectEdit.label};

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
  }
`;

export const BilingLabel = styled.div<{ nowrap?: boolean }>`
  color: ${({ theme }) => theme.projectEdit.label};
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: -0.02em;
  white-space: pre-wrap;
  width: 100%;

  ${({ nowrap }) => nowrap && css`
    white-space: nowrap !important;
  `}

  a {
    color: inherit;
    text-decoration: underline;
    transition: all .2s ease;
    &:hover{
      color: #151514;
      text-decoration: none;
    }
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
  }
`;

export const BilingWrapper = styled(FlexBox)<{ isCompetitionEdit?: boolean, disableOffset?: boolean, isPresentation?: boolean }>`
  width: ${({ isCompetitionEdit }) => isCompetitionEdit ? '170px' : '100%'};
  min-width: ${({ isCompetitionEdit }) => isCompetitionEdit ? '170px' : '127px'};
  margin-right: ${({ isCompetitionEdit }) => isCompetitionEdit ? '32px' : '24px'};
  max-width: ${({ isPresentation }) => isPresentation ? 'none' : '344px'};

  .add-button, .switcher-container {
    min-width: 400px;
  }

  input.competition-checkbox {
    
    width: 24px!important;
    height: 24px!important;
  }

  input ~ .competition-checkbox {
    width: 24px;
    height: 24px;
    background: ${({theme}) => theme.competition.input.checkbox.bg} !important;
    border-color: ${({theme}) => theme.competition.input.checkbox.border} !important;
    
    svg {
      path {
        fill: ${({theme}) => theme.competition.input.checkbox.icon};
      }
    }
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {

    ${({ isCompetitionEdit }) => isCompetitionEdit && css`
      width: 115px;
      min-width: 115px;
      margin-right: 24px;
    `};
    .add-button, .switcher-container {
      min-width: 330px;
      max-width: 330px;
    }
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    margin-bottom: ${({isCompetitionEdit, disableOffset}) => (isCompetitionEdit || disableOffset) ? '0' : '16px'};
    
    .add-button, .switcher-container {
      width: calc(100% - 40px);
      min-width: calc(100% - 40px);
    }
  }

  @media(max-width: 834px) {
    margin-right: ${({isCompetitionEdit}) => isCompetitionEdit ? 'auto' : '24px'};
  }


  @media(max-width: ${LayoutConst.screen.s -1}px) {
    ${({ isCompetitionEdit }) => isCompetitionEdit ? css` 
      margin-right: 0;
      margin-bottom: 16px;
    ` : null};
  }
`;

export const TagsGridNew = styled(BTagsGridNew)<{ isEducationTag?: boolean }>`
  margin-bottom: 0;

  >div {
    border-color: ${({theme}) => theme.projectEdit.mobile.buttons.border};

    span {
      color: ${({theme, isEducationTag}) => !isEducationTag && theme.projectEdit.btns.tag.color} !important;
    }

    :hover {
      border-color: ${({theme}) => theme.projectEdit.mobile.buttons.border} !important;
    }
  }
  
  > div > div {
      .icon {
        svg path {
          fill: ${({theme}) => theme.projectEdit.label} !important;
        }
      }
    }
`;

export const ContentAddContainer = styled(FlexBox)<{ fs?: boolean }>`

  ${({ fs }) => fs ? css`
    max-width: 100%;
    width: 100%;
  `: css`
    max-width: calc(100% - 100px);
    width: calc(100% - 100px);
  `};
   .education-tag, .pure-tag-with-elements{
      span{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 184px;
      }
  }
  .place-top::before{
        content: none !important;
    } 

  @media (max-width: ${LayoutConst.screen.m}px) {
    ${({ fs }) => fs ? css`
      max-width: 100%;
      width: 100%;
    `: css`
      max-width: calc(100% - 120px);
      width: calc(100% - 120px);
    `};
  
  }

  & ${AddButton} {
    &:not(:first-child) {
      margin-left: 16px;
      margin-bottom: 10px;
    }
  }
`;

export const ProjectEditPageViewportLayout = styled(PageViewportLayout)<{disableOffsetTop?: boolean, isLMS?: boolean}>`
  
  margin-top: 14px;

  @media (max-width: ${LayoutConst.screen.mac13 }px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    margin-top: ${({ isLMS }) => isLMS ? '14px' : '12px'};
  }
  @media (max-width: ${LayoutConst.screen.md}px) {
    margin-top: ${({ isLMS }) => isLMS ? '14px' : '10px'};
  }
  
  ${({disableOffsetTop, isLMS}) => disableOffsetTop && !isLMS && css`
    margin-top: 0;
  `}
`

export const ProjectEditTagsAdd = styled.div`
  cursor: pointer;
  margin-top: 12px;
`

export const SectionBottom = styled(FlexBox)`
  flex-direction: column;
  justify-content: space-between;
  height: 100%;

  @media(max-width: ${LayoutConst.screen.m}px) {
    justify-content: flex-end;
  }
`

export const ShadowWarning = styled(FlexBox)`
  justify-self: flex-end;
  margin-top: 16px;

  * {
    flex-shrink: 0;
  }
`

export const WarningText = styled(FInter.SmallTextDiv)`
  margin-left: 13px;
  max-width: 391px;
  width: 100%;
  font-size: 15px;
  line-height: 20px;
`

export const Footnote = styled(FInter.SmallTextDiv)`
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 11px;
    line-height: 13px;
  }
`

export const CopyLinkButton = styled(MagicBox)`
  cursor: pointer;
`

export const PlacesButtonWrap = styled(FlexBox)`
  > div {
    height: 36px;
    min-width: 190px;
    max-width: 207px;
    cursor: pointer;
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    > div {
      width: 100%;
      height: inherit;
      min-width: inherit;
      max-width: inherit;
    }
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    > div {
      width: 100%;
      height: inherit;
      min-width: inherit;
      max-width: inherit;
    }
  }
`;


export const CreateVotingButtonWrapper = styled(FlexBox)`
  flex-grow: 1;
  align-items: flex-end;
  justify-content: flex-end;

  @media (max-width: ${LayoutConst.screen.s}px) {
    margin: 16px 0;
  }
`;

export const PlacesButtonsContainer = styled(FlexBox)`
  flex-flow: row;

  ${PlacesButtonWrap}:last-child {
    width: 207px;
  }


  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    flex-flow: column;

    ${PlacesButtonWrap}:last-child {
      width: 100%;
    }
     > div {
      margin-left: 0 !important;
     }
    > div:first-of-type {
      margin-bottom: 16px;
    }
  }
`;


export const BookLink = styled(Link)<{ h: string }>`
  color: ${(p) => p.h} !important;
  cursor: pointer;
  font-weight: bold;

  &:hover {
    text-decoration: none;
    color: ${(p) => p.h} !important;
  }
`;

export const ErrorItem = styled(FInter.SmallTextFlex)`
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  display: flex;
  align-items: baseline;
  color: ${({ theme }) => theme.projectEdit.label};

  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
    margin-left: 0 !important;
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
  }
`;

export const RequiredErrorMsg = styled.div`
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 16px;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.projectEdit.label};
  padding-left: 4px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
  }
`;

export const RegNumberInput = styled(Input.Text)`
  padding-top: 0;
  padding-bottom: 0;
  input::placeholder {
    font-size: 17px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px; /* 129.412% */
    letter-spacing: -0.34px;
    white-space: nowrap;
    color: ${Colors.galBlack31};

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      font-size: 13px;
      line-height: 16px;
    }
  }

  input:hover {
    &::placeholder {
      color: ${Colors.galBlack31} !important;
    }
  }
`

export const ProtectGroupWrapper = styled(FlexBox)<{isCGrave?: boolean}>`
    flex-flow: column;
    width: 100%;

    input {
        background-color: ${({ theme, isCGrave }) => theme.mainSearchBar.input.bg} !important;
        color: ${({ theme }) => theme.mainSearchBar.text.color} !important;
        height: 46px;
        max-height: 46px;
        min-height: 46px;
        border-color: transparent !important;
        border-radius: 3px;
        outline: none;

        ::placeholder {
            color: ${({ theme }) => theme.projectEdit.protectBlock.input.placeholder.color} !important;
        }
    }
`;

export const InfoMsg = styled.span`
    font-size: 13px;
    line-height: 16px;
    color: ${({ theme }) => theme.projectEdit.label} !important;

    @media (max-width: ${LayoutConst.screen.mac13}px) {
      font-size: 11px;
      line-height: 13px;
    }
`;

export const TagIconWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  height: 100%;
  margin-left: 8px;
`;

export const ProjectRequiredTag = styled.div``;
export const ProjectTag = styled.div``;

export const AuthorsOffsetContainer = styled(FlexBox)<{ orientation?: 'row' | 'column' | 'wide'}>`
  position: relative;
  ${({ orientation }) => orientation === 'row' ? css`
    margin-left: 176px;

    @media (max-width: ${LayoutConst.screen.m}px) {
      margin-left: 0;
    }
  ` : css``};
`;import styled, { createGlobalStyle, css } from "styled-components";
import {Colors, FInter, FlexBox, MagicBox} from "@brg/ui";
import changebg from "./changebg.svg";
import changebgsquare from "./changebgsquare.svg";
import { bColor } from "../../../core/utils/bColor";
import { LabelRedStar } from "../designerEditView/styles";
import { IconWrapperAdd } from "../../assets/styles";
import { BTagsGrid } from "../../../core/components";
import { LayoutConst } from "core/modules";
import { FadeAnimation } from "./SelectPointComponentNext";
import hexToRGB from "shared/helpers/hexToRGB";
import {PageViewportLayout} from "../../components/template";
import {Link} from "react-router-dom";
import { Input } from "@brg/input";
import { BTagsGridNew } from "core/components/bTag/bTagsGridNew/bTagsGridNew";

export const ProjectAuthorsWrapper = styled(FlexBox)<{ isTeamEdit?: boolean, isCompetitionEdit?: boolean, isProjectEdit?: boolean, isCompetitions?: boolean, isLMS?: boolean }>`

${({ isTeamEdit, isCompetitionEdit }) => (isTeamEdit || isCompetitionEdit) ? css`
  max-width: 100%;
  width: 100%;

  .add-button {
    height: ${isTeamEdit ? '36px' : '32px'};
    max-height: ${isTeamEdit ? '36px' : '32px'};
    min-height: ${isTeamEdit ? '36px' : '32px'};
    span {
      font-size: ${isTeamEdit ? '15px' : 'inherit'};
      line-height: ${isTeamEdit ? '20px' : 'inherit'};
    }
  }

  .input-wrapper {
    background-color: ${({theme}) => theme.competition.input.bg} !important;
    color: ${({theme}) => theme.competition.input.inputText} !important;
    height: 46px;
    border-radius: 3px;
  }

  .result-dropdown-wrapper {
    * {
      background-color: ${({theme}) => theme.competition.input.bg};
    }
  }

` : null};

  & > :first-child {
    margin-bottom: 16px;
  }
  ${({ isProjectEdit }) => isProjectEdit ? css`
  @media(max-width: ${LayoutConst.screen.m}px){
    & > :first-child {
      margin-bottom: 24px;
    }
  }

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    & > :first-child {
      margin-bottom: 16px;
    }
  }
  ` : null};

    ${({ isTeamEdit, isCompetitionEdit, isLMS, isProjectEdit }) => (isTeamEdit) ? null : isLMS ? css`
    .input-wrapper {
      height: 100%;
      input {
        height: 100%;
      }
    }
    ` : isCompetitionEdit ? css`
    .input-wrapper {
      height: 40px;
      input {
        height: 40px;
      }
    }
    ` : isProjectEdit ? css`

      .search-wrapper_second, 
      .input-wrapper, input, 
      .dropdown-wrapper, 
      .item, 
      .dropdown-wrapper__text,
      .search-msg {
        background-color: ${({theme}) => theme.mainSearchBar.bg} !important;
        color: ${({theme}) => theme.competition.input.inputText} !important;
      }

      input {
        ::placeholder {
          color: ${({theme}) => theme.mainSearchBar.input.placeholder};
        }
      }

      @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        max-width: 100%;

        .search-wrapper {
          max-width: 256px !important;
        }
      }

      @media(max-width: ${LayoutConst.screen.m}px) {
        .search-wrapper {
          max-width: 100% !important;
        }
      }
    ` : css`
    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      max-width: 100%;



      .search-wrapper {
        max-width: 293px !important;
      }
    }

    @media(max-width: ${LayoutConst.screen.m}px) {
      .search-wrapper {
        max-width: 100% !important;
      }
    }
    `}

  @media (max-width: ${LayoutConst.screen.md}px) {
    & > :not(:first-child) {
      margin-left: 20px;
    }
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    flex-flow: column wrap;

    & >:not(:first-child) {
      margin-left: 0;
    }
  }

  @media(max-width: ${LayoutConst.screen.s}px) {
    max-width: 100%;
    width: 100%;
  }
  
  ${({ isCompetitions }) => isCompetitions && css`
    @media (max-width: ${LayoutConst.screen.md}px) {
      width: 100%;
      max-width: none;
    }
    @media (max-width: ${LayoutConst.screen.s - 1}px) {
      width: 100%;
      max-width: none;
    }
    `}
`;

export const ProjectLocationWrapper = styled(FlexBox)<{isMobile?: boolean}>`
  place-items: ${p => p.isMobile ? "start" : "normal"};

  * {
    margin-left: ${p => p?.isMobile ? '0 !important' : 'inherit'};
  }

  @media(max-width: ${LayoutConst.screen.sm}px) {
    flex-flow: column;
    place-items: flex-start;

    & * {
      margin-left: 0 !important;
    }
  }
`;

export const ProjectEditPageContainer = styled(FlexBox)<{ isFullHeight?: boolean, reverseBlocksOnMob?: boolean, isProjectEdit?: boolean }>`
  flex-direction: column;
  width: 100%;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  .brg-input__value-container {
    height: 34px;
  }
  
  .white_bg {
   .brg-input__control, input {
        background-color: ${({ theme }) => theme.projectEdit.imgContainerBg};
        border-color: transparent;

            .brg-input__placeholder {
                color: #909090;
            }
            &:focus {
                border-color: #30363A;
                .brg-input__placeholder {
                    color: #909090;
                }
            }
            &:active {
                border-color: #30363A;
                .brg-input__placeholder {
                    color: #909090;
                }
            }
            &:hover {
                border-color: #30363A;
                .brg-input__placeholder {
                    color: #909090;
                }
            }

    }

    .brg-input__multi-value__label, .brg-input__single-value  {
        color: #151514;
    }

    .brg-input__multi-value {
        background-color: transparent;
        padding-top: 4px;
        svg path {
            fill: #151514;
            cursor: pointer;
        }
    }

    .brg-input__multi-value__remove {
        cursor: pointer;
        &:hover {
            background-color: transparent;
        }
    }

    .brg-input__menu-list {
        &::-webkit-scrollbar {
          height: 1px;
          width: 2px;
        }
        &::-webkit-scrollbar-track {
          border-radius: 10px;
          background: ${({theme}) => theme.competition.input.bgActive} !important;
        }
        &::-webkit-scrollbar-thumb {
          background: ${({theme}) => theme.competition.input.inputText} !important;
        }
      }
    
      .brg-input__menu {
        background-color: ${({theme}) => theme.competition.input.bg} !important;
    
        .brg-input__option {
          cursor: pointer;
          color: ${({theme}) => theme.competition.input.inputText} !important;
          svg {
            path {
              fill: ${({theme}) => theme.competition.input.inputText} !important;
            }
          }
        }
        .brg-input__option--is-focused {
          background-color: ${({theme}) => theme.competition.input.bgActive} !important;
        }
        .brg-input__option--is-focused:hover {
          background-color: ${({theme}) => theme.competition.input.bgActive} !important;
        }
      }

      .brg-input__indicators {
        align-items: start;
      }
      
      .brg-input__indicator {
        padding-top: 14px;
        margin-right: 0;
        svg {
          path {
            fill: ${({theme}) => theme.competition.input.inputText} !important;;
          }
        }
      }

    input {
        &:disabled {
            color: #909090 !important;
        }
    }

    .showcase-switcher {
        margin: auto 0 0 0;
    }
  }

  .tagss {
    .brg-input__control {
      width: 432px;
      overflow-x: scroll;
      overflow-y: hidden;
      padding-top: 3px;

      &::-webkit-scrollbar {
        display: none;
      }
    }

    .brg-input__value-container {
      width: auto !important;
      min-width: 10000px;
      max-width: 10000px;
      height: 40px;
      overflow: hidden;
    }
  }

  .brg-input__control {
    .gixVUY {
      top: -1px;
    }
  }

  .brg-input__option {
    position: relative;
  }

  .brg-input__menu-list {
    //min-height: 280px;
  }

  .brg-input__menu {
    z-index: 2000;
  }

  //@fixme: Z-position error
  .brg-input__menu {
    z-index: 100 !important;
  }

  .head__grey {
    margin-top: 0;
    padding-top: 0;
  }

  .brg-input__value-container {
    overflow: hidden;
    max-height: 40px;
  }

  @media (max-width: 940px) {
    margin-top: 0px;

    ${({ reverseBlocksOnMob }) => 
      reverseBlocksOnMob 
      ? 
      css`
        .author-wrapper {
          order: 2;
          margin-top: 32px;
        }
        .tags-wrapper {
          order: 1;
        }
        .place-wrapper {
          order: 3;
        }
        .errors-wrapper {
          order: 4;
        }
      ` 
      : null};

      .mobile-block-2 {
        order: 1;
      }
      .game-create-wrapper {
        order: 11;
        margin-top: 0!important;
      }
      .voting-checkbox-wrapper {
        order: 10;
        margin-top: 24px;
      }
      .mobile-block-3 {
        order: 2;
        flex-direction: column;

        .places-wrapper-tags-block {
          margin-top: 16px;
        }
      }
      .mobile-block-5 {
        order: 10;
        flex-direction: column;
        place-items: baseline;
      }
      .mobile-block-4 {
        order: 3;
        flex-direction: column !important;
        justify-content: flex-start;

        .project-tags-block {
          place-items: flex-start;
        }

        .tags-wrapper-grid-block {
          max-width: 100%;
          margin-top: 16px;
          margin-left: 0;

          * {
            margin-left: 0;
          }
        }
      }

      .mobile-block-15 {
        order: 6;
      }
      .mobile-block-7 {
        order: 5;
      }
      .mobile-block-6 {
        order: 4;
        flex-direction: column !important;
        justify-content: flex-start;

        .project-tags-block {
          place-items: flex-start;
        }

        .tags-wrapper-grid-block {
          max-width: 100%;
          margin-top: 16px;
          margin-left: 0;

          * {
            margin-left: 0;
          }
        }
      }
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    margin-top: 24px;
  }

  // ${({ isProjectEdit}) => isProjectEdit ? css`
  //   @media(max-width: 940px) {
  //     margin-top: 0;
  //   }
  // ` : null};
    
  ${({ isFullHeight}) => isFullHeight ? css`
    @media(min-width: ${LayoutConst.screen.s}px) {
      height: 100%;
    }
  `: null};
`;

export const ProjectEditPageGrid = styled(FlexBox)<{ isTeamPage?: boolean, isAdditional?: boolean }>`
  flex-direction: column;
  width: 100%;
  height: 100%;

  .checkbox {
    &:hover {
        background-color: transparent !important;
    }
  }

  @media(max-width: 1280px) {
   .books-publisher-wrap, .books-biblio-wrap {
      flex-direction: column;
      align-items: flex-start;
    }
    .books-label {
      margin-bottom: 16px;
    }
  }

  @media(max-width: 940px) {

    .books-tags-wrap {
      flex-flow: column;
    }

    ${({ isTeamPage, isAdditional }) => isTeamPage ? css`
      margin: 0 auto;
      padding-top: ${isAdditional ? 0 : '24px'};
      justify-content: center;
      max-width: 760px;

      > div {
        width: 760px;
      }
    ` : null};

    .mobile__wrap {
      flex-wrap: wrap !important;
    }
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    ${({ isTeamPage }) => isTeamPage ? css`
      margin: 0 20px;
      justify-content: center;
      max-width: 760px;


    > div {
      width: 760px;
    }
  ` : null};
    .errors-wrapper {
      order: 10;
      margin-bottom: 24px;
    }
  }

  @media(max-width: ${LayoutConst.screen.s}px) {

    ${({ isTeamPage }) => isTeamPage ? css`
      width: calc(100% - 20px);
      margin: 0 auto;

      > div {
        width: 100%;
      }
  ` : css`
      max-width: 100%;
      //width: calc(100% - 20px);
      width: 100%;
      margin: 0 auto;

      > div {
        width: 100%;
      }
      .errors-wrapper {
        margin-bottom: 16px;
      }
  `}
  }

`;

export const QueuePublishButton = styled.div`
    display: flex;
    padding: 12px 48px;
    justify-content: center;
    align-items: center;

    border-radius: 3px;
    background: ${Colors.galBlack100};

    color: #FFF;
    font-family: Inter;
    font-size: 17px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: -0.34px;
    
    @media (max-width: ${LayoutConst.screen.sm}px) {
        width: 100%;
    }
`

export const ProjectEditPageGridRow = styled(FlexBox)<{ isProjectEdit?: boolean, isBook?: boolean, center?: boolean, isTeamEdit?: boolean, isCheckbox?: boolean, switchValue?: number, isProDeziiign?: boolean  }>`

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }

  ${({ isProjectEdit }) => isProjectEdit ? css`

    display: flex;
    align-items: center;
    height: 48px;
    max-height: 48px;
    min-height: 48px;

    @media (max-width: ${LayoutConst.screen.mac13}px) {
      height: 40px;
      max-height: 40px;
      min-height: 40px;
    }
  
    ` : null};


  ${({ isTeamEdit }) => isTeamEdit && css`
    input {
      padding-top: 15px;
      padding-bottom: 13px;
    }

    .info-icon-wrapper{
      margin-right: 8px;
    }

    .add-button {
      height: 36px;
      max-height: 36px;
      min-height: 36px;

      span {
        font-size: 15px;
        line-height: 20px;
      }
    }

    .small-caption {
      font-size: 17px;
      line-height: 22px;
    }

    .brg-input__control {
      .brg-input__indicator {
        opacity 1 !important;
        transition: none;
        svg path {
            fill: #909090 !important;
        }
      }
    }
      @media(max-width: ${LayoutConst.screen.m}px){
        max-width: 720px;
    }
  `};

  .input-span {
    color: rgba(144, 144, 144, 1);
  }

  .header-description {
    font-size: 17px;
    line-height: 22px;
    font-weight: 400;
    color: rgba(144, 144, 144, 1);
  }

  .showcase-switcher {
    margin-bottom: 0;
    height: 24px;
    width: 48px;

    span:not(:last-child) {
      background-color: rgba(112, 112, 111, 1);
      border-radius: 19px;
    }

    span:last-child {
      top: 50%;
      transform: translateY(-50%);
      width: 16px;
      height: 16px;
      border-radius: 50%;
      left: 10%;
      ${({ switchValue }) => switchValue === 0 ? css`
      background-color: #fff;
      ` : css`
        left: 57%;
      `};
    }
  }

  .tags-container {
    max-width: 413px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      max-width: 293px;
    }

    @media (max-width: ${LayoutConst.screen.md}px) {
      max-width: 100%;
    }
  }
  
  ${({ center}) => center ? css`
    place-items:center;
  `: null};
  &:not(:first-child) {
    margin-top: ${({ isTeamEdit, isProDeziiign }) => isTeamEdit || isProDeziiign ? 0 : '24px'};
  }

  @media(max-width: 940px) {
    ${({ center}) => center ? css`
    place-items:normal;
  `: null};
    .project-tags-block {
      flex-direction: column !important;
    }

    &:not(:first-child) {
      margin-top: ${({ isTeamEdit, isProDeziiign }) => isTeamEdit || isProDeziiign ? 0 : '24px'};
    }
    &.mobile__hide {
      display: none;
    }
  }

  @media(max-width: ${LayoutConst.screen.m}px) {
    align-items: start;
    flex-flow: column;
    width: 100%;
    
    ${({ isTeamEdit, isCheckbox }) => isTeamEdit ? css`
      flex-flow: ${isCheckbox ? 'row-reverse' : 'column'};
      width:100%;
      &:not(:first-child) {
        margin-top: 8px;
      }
    ` : null};
  }

  @media(max-width: 440px) {

    ${({ isBook }) => isBook ? css`
    .add-button {
      margin-left: 0 !important;
    }
      input {
        max-width: 202px;
      }
    ` : null}
  }
`;

export const AuthorsLabelContainer = styled.div<{ 
  isTeamEdit?: boolean,
  isPresentation?: boolean,
  isProjectEditPage?: boolean
}>`
  display: flex;
  align-items: center;
  margin-right: 16px;
  
  ${({ isTeamEdit, isPresentation, isProjectEditPage }) => {
    if (isPresentation) {
      return css`
        display: none;
      `;
    }
    if (isProjectEditPage) {
      return css`
        margin-right: 0;
      `;
    }
    if (isTeamEdit) {
      return css`
        margin-right: 12px;
      `;
    }

    
    return css`
      margin-right: 16px;
    `;
  }}

  > div {
    width: 160px;
    min-width: 160px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      width: 130px;
      min-width: 130px;
    }
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    margin-right: 12px;
  }
`;

export const ProjectEditPageGridAuthorRow = styled(FlexBox)<{ isTeamEdit?: boolean, isCompetitions?: boolean, isPresentationLMS?: boolean, isPresentation?: boolean }>`
  place-items: flex-start;

  ${({ isPresentation }) => isPresentation && css`
    width: 100%;

    input {
      background-color: #fff;
    }

    .input-wrapper {
      padding: 0;
    }

    .text-wrapper {
      font-size: 13px;
      line-height: 16px;
      overflow-y: hidden;
    }
  `};
  &:not(:first-child) {
    margin-top: ${({ isTeamEdit }) => isTeamEdit ? 8 : '8px'};
    
    @media (max-width: ${LayoutConst.screen.m}px) {
      margin-top: ${({ isTeamEdit }) => isTeamEdit ? '24px' : '0'};

      .basic-multi-select {
        margin-top: 16px !important;
      }
    }
  }

  @media(max-width: ${LayoutConst.screen.s}px) {
    ${({ isTeamEdit }) => isTeamEdit ? css`
      flex-flow: column;
      width: 100%;
    ` : null};
  }
  
  ${({isCompetitions}) => isCompetitions && css`
    margin-top: 24px;
    margin-bottom: 0!important;

    @media (max-width: ${LayoutConst.screen.md}px) {
      width: 100%;
      max-width: none;
    }
  `}
  
  ${({isPresentationLMS}) => isPresentationLMS && css`
    flex-direction: column;
  `}
`;

export const ProjectEditPageGridLabel = styled(FInter.SmallTextFlex)<{ 
  minHeight?: number, 
  isPresentation?: boolean, 
  isProjectEditPage?: boolean, 
  fullWidth?: boolean, 
  isTeamEdit?: boolean, 
  isLMS?: boolean, 
  isTable?: boolean, 
  isCheckbox?: boolean, 
  fixedHeight?: boolean, 
  nowrap?: boolean, 
  isPresentationLMS?: boolean, 
  isTeacherLMS?: boolean 
}>`
  font-size: 15px;
  line-height: 20px;
  color: ${({ theme }) => theme.projectEdit.label};
  width: ${({ fullWidth, isProjectEditPage }) => fullWidth ? 'auto' : isProjectEditPage ? '160px' : '160px'};
  min-width: ${({ fullWidth, isProjectEditPage }) => fullWidth ? 'auto' : isProjectEditPage ? '160px' : '160px'};
  align-items: center;
  margin-right: 24px;
  position: relative;

  ${({ minHeight }) => minHeight && css`
    min-height: ${minHeight}px;
    margin-top: 0 !important;
  `};

  ${({ fixedHeight }) => fixedHeight ? css`
    height: 32px;
    max-height: 32px;
    padding-top: 0;
  ` : null};

  ${({ nowrap }) => nowrap && css`
    white-space: nowrap;
  `};

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
    margin-right: 16px;
    width: ${({ fullWidth, isProjectEditPage }) => fullWidth ? 'auto' : isProjectEditPage ? '130px' : '130px'};
    min-width: ${({ fullWidth, isProjectEditPage }) => fullWidth ? 'auto' : isProjectEditPage ? '130px' : '130px'};
    ${({ fixedHeight }) => fixedHeight ? css`
    padding-top: 0;
    min-height: 40px;
  ` : null};

  ${({ nowrap }) => nowrap && css`
    white-space: nowrap;
  `};

    ${({ isLMS }) => isLMS ? css`
      min-width: auto;
      width: 100%;
      margin-bottom: 8px;    
    ` : null};
  }

  @media (max-width: 940px) {
    font-size: 13px;
    line-height: 16px;
    width: ${({ isPresentation, isTeacherLMS, isLMS, fullWidth }) => fullWidth || isPresentation || isTeacherLMS || isLMS ? 'auto' : '76px'};
    min-width: ${({ isPresentation, isTeacherLMS, isLMS, fullWidth }) => fullWidth || isPresentation || isTeacherLMS || isLMS ? 'auto' : '76px'};
    white-space: ${({ nowrap }) => nowrap ? 'nowrap' : 'wrap'}!important;
    margin-bottom: 8px;
    margin-right: ${({ isPresentation }) => isPresentation ? '0' : '24px'};

    ${({ isTeamEdit, isTable }) => isTeamEdit ? css`
      min-width: 170px;
      font-size: ${isTable ? '13px' : '17px'};
      line-height: ${isTable ? '16px' : '22px'};
  ` : null};
  }

  @media(max-width: 834px) {
    white-space: ${({ nowrap }) => nowrap ? 'nowrap' : 'wrap'}!important;

    ${({ isTeamEdit }) => isTeamEdit ? css`
      min-width: 170px;
    ` : null};
  }

  @media(max-width: ${LayoutConst.screen.s}px) {
    ${({ isTeamEdit, isTable, isCheckbox }) => isTeamEdit ? css`
      margin-bottom: ${isCheckbox ? 0 : '8px'};
      font-size: ${isTable ? '13px' : '15px'};
      line-height: ${isTable ? '16px' : '20px'};
      white-space: nowrap;
      width: 100%;
      min-width: none;
    ` : null};
  }

  ${({ isPresentationLMS, isPresentation }) => (isPresentationLMS || isPresentation) && css`
    min-width: auto;
    width: auto;
  `};
}
`;

export const ProjectEditPageGridStartLabel = styled(ProjectEditPageGridLabel)`
  align-items: start;
`;

// выбор бг на дезигне

interface IBgLayout {
  color: string;
  brighter?: string;
  darker?: string;
}

export const GlobalColoring = createGlobalStyle<IBgLayout>`
  ${(props) =>
    props.color && props.color !== ""
      ? css`          .custom_title {
            color: ${bColor.isDark(props.color)
              ? Colors.geoWhite100
              : Colors.galBlack100};
          }
          ${LabelRedStar} {
            color: ${bColor.isDark(props.color) ? "#ff0000" : Colors.redFailed};
          }
        `
      : null};
`;
export const BgLayout = styled.div<IBgLayout>`
  background-color: ${(props) =>
    props.color === "" ? "inherit" : props.color};
  transition: background-color 500ms;

  // вырубаем линии у лонгридов

  @media(max-width: 940px) {
    .add-block__wrap {
      display: none !important;
    }
  }
`;

export const ChangeBgBtn = styled.div`
  display: inline-block;
  width: 36px;
  height: 36px;
  background: url(${changebgsquare}) no-repeat center;
  cursor: pointer;
  position: relative;
  vertical-align: middle;
  border-radius: 3px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: 28px;
    height: 28px;
  }
`;

export const UserColorChoose = styled.div`
  position: relative;
  display: inline-block;
  width: 32px;
  height: 32px;
  vertical-align: middle;
  cursor: pointer;
  margin: 0 16px 16px 0;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: 28px;
    height: 28px;
    margin: 0 11px 16px 0;
  }
`;

export const UserColorChooseBlock = styled.div<{mobileLeftOffset?: number | string}>`
  position: absolute;
  left: -70px;
  bottom: 40px;
  box-shadow: 0 1px 16px 0 rgba(34, 60, 80, 0.2);
  z-index: 101;
  width: 100%;

  @media (max-width: 940px) {
    left: 0;
  }

  @media (max-width: 500px) {
    ${p => p.mobileLeftOffset && `left: -${p.mobileLeftOffset}px;`}
  }
`;

export const AddButton = styled(IconWrapperAdd)<{ disabled?: boolean, fs?: boolean, isTeamEdit?: boolean }>`
  cursor: pointer;
  height: 48px;
  display: ${p => p?.disabled ? 'none' : 'flex'};
  align-items: center;
  
  &:not(:first-child) {
    margin-left: 16px;
  }

  //todo проверить. Не работает и нет такого кейса в макетах.
  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    height: 40px;
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    ${({ fs }) => fs ? css` width: 100%` : null};
  }
`

export const AlignedTagsGrid = styled(BTagsGrid)<{ fs?: boolean, isProjectEdit?: boolean, isTeamEdit?: boolean, maxHgt?: boolean }>`
  align-items: center;
  max-width: ${fs => fs ? '100%' : 'calc(100% - 40px)'};

  ${({ isProjectEdit, isTeamEdit, maxHgt }) => ((isProjectEdit || isTeamEdit) && maxHgt) ? css`
    max-height: ${isTeamEdit ? '85px' : '135px'};
    overflow-y: auto;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      max-height: ${isTeamEdit ? '85px' : '120px'};
      max-width: ${isProjectEdit ? '293px' : '100%'};
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
      max-height: ${isTeamEdit ? '85px' : '135px'};
      margin-right: ${isTeamEdit ? '0': 'inherit'};
    }

    @media(max-width: 834px) {
      max-height: ${isTeamEdit ? '85px' : '115px'};
    }

    @media(max-width: 576px) {
      max-height: 135px;
    }
  ` : null};
`


export const MobilePadding = styled.div`
  margin-top: 80px;
`;

export const MobileCreateButton = styled.button`
  position: fixed;
  top: 18px;
  z-index: 100000;
  right: 69px;
  color: white;
  background: #151514;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  padding: 4px 16px;
  font-weight: 700;
  font-size: 13px;
  border: none;
  line-height: 20px;
  &:disabled {
    opacity: 0.7;
  }
`;

export const MapSearchContainer = styled(FlexBox)<{ offset?: boolean }>`
  position: fixed;
  display: flex;
  width: 100%;
  top: 48px;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1006;
  animation: 0.2s ease-in forwards ${FadeAnimation};
  background-color: ${(p) => p.theme.map.bg};

  @media(max-width: ${LayoutConst.screen.md}px) {
    top: ${({ offset }) => offset ? '48px' : 0};
    z-index: ${({ offset }) => offset ? '1006' : '99999'};
  }
`;

export const MapTopLine = styled.div`
  @media(max-width: ${LayoutConst.screen.md}px) {
    content: '';
    width: 38px;
    height: 2px;
    position: absolute;
    display: inline-block;
    background-color: #6C7073;
    top: 6px;
    left: 50%;
    transform: translateX(-50%);
  }
`;

export const MapSearchContentWrapper = styled(FlexBox)`
  background-color: ${(p) => p.theme.map.bg};
  margin: 0 auto;
  width: calc(65% + 40px + 400px);
  max-width: 100%;
  justify-content: center;

  @media(max-width: ${LayoutConst.screen.l}px) {
    padding: 0 10px;
  }

  // @media(max-width: ${LayoutConst.screen.md}px) {
  //   width: 100%;
  //   overflow-y: auto;
  //   position: relative;

  // }
`;

export const GeoLocationText = styled(FInter.SmallTextBoldDiv)`
  color: #E7E7E7;
  font-size: 17px;
  line-height: 22px;
  font-weight: 400;
`;

export const GeoLocationCoordsText = styled.div`
  font-size: 13px;
  line-height: 16px;
  font-weight: 400;
`;

export const LongreadWrapper = styled(FlexBox)<{ hseFonts?: boolean }>`
  * {
    font-family: ${({ hseFonts }) => hseFonts ? 'HSE Slab' : 'Inter'};
  }
`;


export const CheckboxRoot = styled.div<{ checked?: boolean, isProjectPage?: boolean }>`
  width: 24px;
  height: 24px;
  min-width: 24px;
  border: 1px solid ${({ theme, isProjectPage }) => isProjectPage ?
    theme.projectEdit.btns.age.border : theme.projectEdit.btns.lang.biling.border};
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({theme, isProjectPage}) => isProjectPage ? theme.projectEdit.btns.age.bg : theme.projectEdit.btns.lang.biling.bg};
  input {
    display: none;
  }

  svg path {
    fill: ${({ theme }) => theme.projectEdit.btns.age.icon.color};
  }
`
export const BilingualismWrapper = styled(FlexBox)`
    gap: 0 24px;
    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      gap: 0 16px;
    }
`;
export const BilingualismContent = styled(FlexBox)`
    gap: 8px;
`;
export const BilingualismLabel = styled(FlexBox)`
  min-width: 160px;
  font-size: 15px;
  line-height: 20px;
  color: ${({ theme }) => theme.projectEdit.label};
  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
    margin-right: 0px;
    min-width: 130px;
  }`
export const BilingualismItem = styled(FlexBox)`
  font-size: 15px;
  line-height: 20px;
  color: ${({ theme }) => theme.projectEdit.label};

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
  }
`;

export const BilingLabel = styled.div<{ nowrap?: boolean }>`
  color: ${({ theme }) => theme.projectEdit.label};
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: -0.02em;
  white-space: pre-wrap;
  width: 100%;

  ${({ nowrap }) => nowrap && css`
    white-space: nowrap !important;
  `}

  a {
    color: inherit;
    text-decoration: underline;
    transition: all .2s ease;
    &:hover{
      color: #151514;
      text-decoration: none;
    }
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
  }
`;

export const BilingWrapper = styled(FlexBox)<{ isCompetitionEdit?: boolean, disableOffset?: boolean, isPresentation?: boolean }>`
  width: ${({ isCompetitionEdit }) => isCompetitionEdit ? '170px' : '100%'};
  min-width: ${({ isCompetitionEdit }) => isCompetitionEdit ? '170px' : '127px'};
  margin-right: ${({ isCompetitionEdit }) => isCompetitionEdit ? '32px' : '24px'};
  max-width: ${({ isPresentation }) => isPresentation ? 'none' : '344px'};

  .add-button, .switcher-container {
    min-width: 400px;
  }

  input.competition-checkbox {
    
    width: 24px!important;
    height: 24px!important;
  }

  input ~ .competition-checkbox {
    width: 24px;
    height: 24px;
    background: ${({theme}) => theme.competition.input.checkbox.bg} !important;
    border-color: ${({theme}) => theme.competition.input.checkbox.border} !important;
    
    svg {
      path {
        fill: ${({theme}) => theme.competition.input.checkbox.icon};
      }
    }
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {

    ${({ isCompetitionEdit }) => isCompetitionEdit && css`
      width: 115px;
      min-width: 115px;
      margin-right: 24px;
    `};
    .add-button, .switcher-container {
      min-width: 330px;
      max-width: 330px;
    }
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    margin-bottom: ${({isCompetitionEdit, disableOffset}) => (isCompetitionEdit || disableOffset) ? '0' : '16px'};
    
    .add-button, .switcher-container {
      width: calc(100% - 40px);
      min-width: calc(100% - 40px);
    }
  }

  @media(max-width: 834px) {
    margin-right: ${({isCompetitionEdit}) => isCompetitionEdit ? 'auto' : '24px'};
  }


  @media(max-width: ${LayoutConst.screen.s -1}px) {
    ${({ isCompetitionEdit }) => isCompetitionEdit ? css` 
      margin-right: 0;
      margin-bottom: 16px;
    ` : null};
  }
`;

export const TagsGridNew = styled(BTagsGridNew)<{ isEducationTag?: boolean }>`
  margin-bottom: 0;

  >div {
    border-color: ${({theme}) => theme.projectEdit.mobile.buttons.border};

    span {
      color: ${({theme, isEducationTag}) => !isEducationTag && theme.projectEdit.btns.tag.color} !important;
    }

    :hover {
      border-color: ${({theme}) => theme.projectEdit.mobile.buttons.border} !important;
    }
  }
  
  > div > div {
      .icon {
        svg path {
          fill: ${({theme}) => theme.projectEdit.label} !important;
        }
      }
    }
`;

export const ContentAddContainer = styled(FlexBox)<{ fs?: boolean }>`

  ${({ fs }) => fs ? css`
    max-width: 100%;
    width: 100%;
  `: css`
    max-width: calc(100% - 100px);
    width: calc(100% - 100px);
  `};
   .education-tag, .pure-tag-with-elements{
      span{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 184px;
      }
  }
  .place-top::before{
        content: none !important;
    } 

  @media (max-width: ${LayoutConst.screen.m}px) {
    ${({ fs }) => fs ? css`
      max-width: 100%;
      width: 100%;
    `: css`
      max-width: calc(100% - 120px);
      width: calc(100% - 120px);
    `};
  
  }

  & ${AddButton} {
    &:not(:first-child) {
      margin-left: 16px;
      margin-bottom: 10px;
    }
  }
`;

export const ProjectEditPageViewportLayout = styled(PageViewportLayout)<{disableOffsetTop?: boolean, isLMS?: boolean}>`
  
  margin-top: 14px;

  @media (max-width: ${LayoutConst.screen.mac13 }px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    margin-top: ${({ isLMS }) => isLMS ? '14px' : '12px'};
  }
  @media (max-width: ${LayoutConst.screen.md}px) {
    margin-top: ${({ isLMS }) => isLMS ? '14px' : '10px'};
  }
  
  ${({disableOffsetTop, isLMS}) => disableOffsetTop && !isLMS && css`
    margin-top: 0;
  `}
`

export const ProjectEditTagsAdd = styled.div`
  cursor: pointer;
  margin-top: 12px;
`

export const SectionBottom = styled(FlexBox)`
  flex-direction: column;
  justify-content: space-between;
  height: 100%;

  @media(max-width: ${LayoutConst.screen.m}px) {
    justify-content: flex-end;
  }
`

export const ShadowWarning = styled(FlexBox)`
  justify-self: flex-end;
  margin-top: 16px;

  * {
    flex-shrink: 0;
  }
`

export const WarningText = styled(FInter.SmallTextDiv)`
  margin-left: 13px;
  max-width: 391px;
  width: 100%;
  font-size: 15px;
  line-height: 20px;
`

export const Footnote = styled(FInter.SmallTextDiv)`
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 11px;
    line-height: 13px;
  }
`

export const CopyLinkButton = styled(MagicBox)`
  cursor: pointer;
`

export const PlacesButtonWrap = styled(FlexBox)`
  > div {
    height: 36px;
    min-width: 190px;
    max-width: 207px;
    cursor: pointer;
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    > div {
      width: 100%;
      height: inherit;
      min-width: inherit;
      max-width: inherit;
    }
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    > div {
      width: 100%;
      height: inherit;
      min-width: inherit;
      max-width: inherit;
    }
  }
`;


export const CreateVotingButtonWrapper = styled(FlexBox)`
  flex-grow: 1;
  align-items: flex-end;
  justify-content: flex-end;

  @media (max-width: ${LayoutConst.screen.s}px) {
    margin: 16px 0;
  }
`;

export const PlacesButtonsContainer = styled(FlexBox)`
  flex-flow: row;

  ${PlacesButtonWrap}:last-child {
    width: 207px;
  }


  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    flex-flow: column;

    ${PlacesButtonWrap}:last-child {
      width: 100%;
    }
     > div {
      margin-left: 0 !important;
     }
    > div:first-of-type {
      margin-bottom: 16px;
    }
  }
`;


export const BookLink = styled(Link)<{ h: string }>`
  color: ${(p) => p.h} !important;
  cursor: pointer;
  font-weight: bold;

  &:hover {
    text-decoration: none;
    color: ${(p) => p.h} !important;
  }
`;

export const ErrorItem = styled(FInter.SmallTextFlex)`
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  display: flex;
  align-items: baseline;
  color: ${({ theme }) => theme.projectEdit.label};

  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
    margin-left: 0 !important;
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
  }
`;

export const RequiredErrorMsg = styled.div`
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 16px;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.projectEdit.label};
  padding-left: 4px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
  }
`;

export const RegNumberInput = styled(Input.Text)`
  padding-top: 0;
  padding-bottom: 0;
  input::placeholder {
    font-size: 17px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px; /* 129.412% */
    letter-spacing: -0.34px;
    white-space: nowrap;
    color: ${Colors.galBlack31};

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      font-size: 13px;
      line-height: 16px;
    }
  }

  input:hover {
    &::placeholder {
      color: ${Colors.galBlack31} !important;
    }
  }
`

export const ProtectGroupWrapper = styled(FlexBox)<{isCGrave?: boolean}>`
    flex-flow: column;
    width: 100%;

    input {
        background-color: ${({ theme, isCGrave }) => theme.mainSearchBar.input.bg} !important;
        color: ${({ theme }) => theme.mainSearchBar.text.color} !important;
        height: 46px;
        max-height: 46px;
        min-height: 46px;
        border-color: transparent !important;
        border-radius: 3px;
        outline: none;

        ::placeholder {
            color: ${({ theme }) => theme.projectEdit.protectBlock.input.placeholder.color} !important;
        }
    }
`;

export const InfoMsg = styled.span`
    font-size: 13px;
    line-height: 16px;
    color: ${({ theme }) => theme.projectEdit.label} !important;

    @media (max-width: ${LayoutConst.screen.mac13}px) {
      font-size: 11px;
      line-height: 13px;
    }
`;

export const TagIconWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  height: 100%;
  margin-left: 8px;
`;

export const ProjectRequiredTag = styled.div``;
export const ProjectTag = styled.div``;

export const AuthorsOffsetContainer = styled(FlexBox)<{ orientation?: 'row' | 'column' | 'wide'}>`
  position: relative;
  ${({ orientation }) => orientation === 'row' ? css`
    margin-left: 176px;

    @media (max-width: ${LayoutConst.screen.m}px) {
      margin-left: 0;
    }
  ` : css``};
`;